import { Component } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { AuthService } from '../providers/auth-service';
import { Storage } from '@ionic/storage';
import { APP_ID_ONESIGNAL, IS_MULTIPLE_SCHOOL } from '../providers/config';
import { DataService } from '../providers/data-service';
import OneSignal from 'onesignal-cordova-plugin';

@Component({
  templateUrl: 'app.html',
  providers: [AuthService]
})
export class MyApp {
  rootPage: any;

  constructor(
    platform: Platform, 
    statusBar: StatusBar, 
    splashScreen: SplashScreen,
    public authService: AuthService,
    public storage: Storage,
    private dataService: DataService
  ) 
  {
    platform.ready().then(() => {
      // Okay, so the platform is ready and our plugins are available.
      // Here you can do any higher level native things you might need.
      statusBar.styleDefault();
      splashScreen.hide();

      this.authService.getCheckAuthJWT()
          .then((data: any) => {

            OneSignal.setAppId(APP_ID_ONESIGNAL);
            // OneSignal.deleteTag('idSekolah');
            OneSignal.deleteTag('kodeSekolah');
            OneSignal.deleteTag('yayasan');
            OneSignal.deleteTag('group');
            OneSignal.deleteTag('idUser');
            OneSignal.deleteTag('idKelas');

            if(data.exp === false) {

              // // OneSignal.sendTag('idSekolah', data.idSekolah);
              OneSignal.sendTag('kodeSekolah', data.kodeSekolah);
              OneSignal.sendTag('yayasan', data.yayasan);
              OneSignal.sendTag('group', data.data.group);
              OneSignal.sendTag('idUser', data.data.data_user.id_user);

              if(data.data.group === "siswa") {
                OneSignal.sendTag('idKelas', data.data.data_kelas[0].id_kelas);
                // OneSignal.sendTag('idUser', data.data.data_user.id_siswa);
              } else if(data.data.group === "guru") {
                OneSignal.sendTag('idKelas', 'many');
                // OneSignal.sendTag('idUser', data.data.data_user.id_pegawai);
              } else {
                OneSignal.sendTag('idKelas', 'operator');
              }
              // // console.log(data);

              // if(data.idSekolah === "developer") {
              //   OneSignal.sendTag('idSekolah', data.idSekolah);
              //   this.rootPage = "SideMenu";
              // } else {
              //   this.rootPage = "Login";
              // }
              this.rootPage = "SideMenu";
            } else {
              // this.rootPage = "Login"; 
              if (IS_MULTIPLE_SCHOOL) {
                this.storage.get('group_sekolah')
                .then(group_sekolah => {
                  //console.log(group_db);
                  if(!group_sekolah) {
                    this.rootPage = "PilihSekolah";        
                  } else {
                    this.rootPage = "Login";
                  }
                });
              } else {
                this.rootPage = "Login";
              }
              
            }
            //this.rootPage = "PilihSekolah";

          }, err => {
            console.log(err);
          });
    });
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts